import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import NarrativeVoting from '@/pages/Narrative/components/NarrativeVoting';
import { CreateAnnouncement } from '@/pages/Narrative/components/CreateAnnouncement';
import { CommentNarrative } from '../CommentNarrative';
import { SetFairValue } from '../SetFairValue';
import { useRef } from 'react';
import { Button } from '@simplywallst/ui-core/next';

// NOTE: This is hardcoded temporarily to show a link for particular narratives.
const NARRATIVE_LINKS = {
  'e84dcb87-8b97-4a56-9dbc-664354cb58cd': 'https://ir.silopharma.com', // SILO
  '5ca876d4-8480-48ec-a2c1-84da3f4df242':
    'https://stockresearchtoday.com/delivering-therapy-where-it-matters', // RNXT
};

type Props = {
  narrative: Narrative;
  onCommentClick: () => void;
};

export const NarrativeActions = ({ narrative, onCommentClick }: Props) => {
  const { id, slug, company, voteCount, isSponsored } = narrative;
  const containerRef = useRef<HTMLDivElement>(null);

  if (!company) return null;

  return (
    <div className="flex w-full flex-wrap justify-start gap-2">
      <SetFairValue
        companyId={company.id}
        narrativeId={id}
        containerRef={containerRef}
        primaryNarrativeCount={narrative.primaryCount}
        isPrimary={narrative.isPrimary}
      />
      {/* NOTE: We'll enable this button when we have third party links provided */}
      {isSponsored && NARRATIVE_LINKS[id] !== undefined && (
        <Button variant="primary" href={NARRATIVE_LINKS[id]} size="medium">
          Learn about {company.tickerSymbol}
        </Button>
      )}
      <NarrativeVoting
        narrativeId={id}
        slug={slug}
        upVotes={voteCount.upvotes}
      />
      <CommentNarrative
        commentKey={narrative.commentKey}
        onCommentClick={onCommentClick}
      />
      <CreateAnnouncement id={id} slug={slug} />
    </div>
  );
};
